import React from "react";
import { ModalBody, ModalFooter, Text } from "@chakra-ui/react";
import { Modal, useTranslation, Button } from "@familyzone/component-library";

interface PurgeConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  description?: string;
}

export const PurgeConfirmModal: React.FC<PurgeConfirmModalProps> = ({ isOpen, onClose, onConfirm, isLoading, description }) => {
  const { t } = useTranslation();
  const defaultDescription = t(
    "All synced data associated with this sync configuration will be permanently deleted. This includes users, groups, classrooms, schools, guardians and any associations."
  );

  return (
    <Modal headerText={t("Confirm Purge")} isOpen={isOpen} onClose={onClose} variant="danger" size="md">
      <ModalBody display={"flex"} flexDirection={"column"} gap={"1rem"} overflow={"hidden"}>
        <Text fontWeight={"bold"} color={"#FF6B6B"}>
          {t("Warning: This action cannot be undone!")}
        </Text>
        <Text>{description || defaultDescription}</Text>
        <Text>{t("Are you sure you want to proceed with the purge?")}</Text>
      </ModalBody>
      <ModalFooter
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button data-testid={"modal-purge-btn"} onClick={onConfirm} variant="danger" disabled={isLoading}>
          {t("Purge Data")}
        </Button>
        <Button onClick={onClose} disabled={isLoading}>
          {t("Cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
